export default {
  namespaced: true,
  state: {
    mixRecommend: {}
  },
  mutations: {
    ADD_MIX_RECOMMEND(state, data) {
      Object.assign(state.mixRecommend, data);
    },
    CLEAR_MIX(state) {
      state.mixRecommend = {};
    }
  },
  actions: {
    addMixRecommend({ commit }, data) {
      commit("ADD_MIX_RECOMMEND", data);
    }
  }
};
